import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-topbar-style1',
  templateUrl: './topbar-style1.component.html',
  styleUrls: ['./topbar-style1.component.css']
})
export class TopbarStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
